import React, { useState, useEffect } from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Typography, 
  Box,
  Checkbox,
  FormControlLabel,
  Link 
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link as RouterLink } from 'react-router-dom';


interface WelcomePromptProps {
  onAccept: () => void;
}

const WelcomePrompt: React.FC<WelcomePromptProps> = ({ onAccept }) => {
  const [open, setOpen] = useState(true);
  const [isAgreed, setIsAgreed] = useState(false);

  const handleAccept = () => {
    // Save to localStorage so we don't show this again
    localStorage.setItem('termsAccepted', 'true');
    setOpen(false);
    onAccept();
  };

  return (
    <Dialog 
      open={open} 
      onClose={() => {}} // Empty function prevents closing by clicking outside
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ 
        backgroundColor: '#002a5a', 
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
        <InfoIcon />
        Welcome to UnitedInTalk
      </DialogTitle>
      
      <DialogContent sx={{ py: 3, mt:1 }}>
        <Typography variant="body1" paragraph>
          Welcome! Please read and agree to the following:
        </Typography>
        
        <Box sx={{ 
          backgroundColor: '#f8f9fa', 
          p: 2, 
          borderRadius: 1,
          border: '1px solid #e0e0e0',
          mb: 1
        }}>
          <Typography variant="body2">
            By using this app you agree to our <Link component={RouterLink} to="/terms" target="_blank">terms of use</Link> and that you are 18 years or older.
          </Typography>
        </Box>
        
        <FormControlLabel
          control={
            <Checkbox 
              checked={isAgreed}
              onChange={(e) => setIsAgreed(e.target.checked)}
              color="primary"
            />
          }
          label="I agree to the terms and confirm I am 18 years or older"
        />
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button 
          variant="contained" 
          color="primary"
          disabled={!isAgreed}
          onClick={handleAccept}
          fullWidth
        >
          Accept & Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WelcomePrompt;